import {Role} from 'Common/permissions/Role';
import {AccessArea} from 'Common/permissions/AccessArea';
import {BrowserId, BrowserOrServerId, sameId} from 'Browser/BrowserId';
import { SiteBasics } from 'Common/SiteBasics';
import { VenueRole } from 'Common/permissions/VenueRole';


export class Roles<Id extends BrowserOrServerId> implements Iterable<Role<Id>>
{
	constructor(
		private roles:Role<Id>[]
	)
	{ }

	public *[Symbol.iterator] (): Iterator<Role<Id>>
	{
		yield *(this.roles)[Symbol.iterator]();
	}

//TODO maybe move into VenueRole, possibly as a static function
	public canAccessArea(area:AccessArea,artistId:Id):boolean 
	{
		for (const role of this.roles) 
			if (role.canAccessArea(area,artistId))
				return true;
		return false;
	}

//TODO maybe move into ArtistRole, possibly as a static function or add ArtistRoles
	public amManager(artistId:Id):boolean 
	{
		for (const role of this.roles) 
			if (role.amManager(artistId))
				return true;

		return false;
	}

	public amGlobalAdmin():boolean 
	{
		for (const role of this.roles)
			if (role.name == 'admin')
				return true;
		return false;
	}

//TODO maybe move into VenueRole, possibly as a static function
	public areas(siteId:Id)
	{
		let areas:string[] = []; 	//XXX could tighten up the type
		
		for (const role of this.roles) {
			const top = role.topAccess();

			if (role.canAccessArea(top,siteId)) 
				areas = [...areas,top.name, ...(top.subAreas().map(i => i.name))];
		}
		return areas;
	}

	public haveVenueRole(site:SiteBasics<BrowserId>)
	{
		for (const role of this.roles) 
			if (role instanceof VenueRole && sameId(role.config?.siteId,site.id)) 
				return true;

		return false;
	}

	public toJson()
	{
		const ret = [];
		for (const r of this.roles)
			ret.push(r.toJson());
		return ret;
	}
}

